/**
 * =========================================================================================
 * Attachment
 * =========================================================================================
 **/

import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {COLOR} from "ubs-framework/v2/common/constant";
import * as Icon from 'ubs-icons';
import {checkAttachment} from "ubs-framework/v2/common/function";

export const FileAttachment = ({doc, file, index, action, type, name, hideDelete}) => {

    const dispatch = useDispatch();

    const _S3_BASE_URL = useSelector(e => e?.common?.S3_BASE_URL);

    const handle = {
        view: (attachment, i) => {
            dispatch({type: 'SET_FILES', payload: {files: attachment?.filter(item => checkAttachment(item?.url) !== 'pdf'), active: i || 0}});
        },
    }

    return (
        <React.Fragment>

            <div className={`u_file-attachment preview ${file?.isDeleted ? 'deleted' : ''}`}>

                <div className={`u_file-attachment-${checkAttachment(file?.url) === 'pdf' ? 'pdf' : 'image'}`}>
                    {
                        checkAttachment(file?.url) === 'pdf' ?
                            <>
                                <Icon.PDF size={14} fill={COLOR.u_red} />
                                <p className="u_one-line">{file?.fileName}</p>
                            </>
                            :
                            <img src={_S3_BASE_URL + file?.url} alt={file?.fileName} />
                    }
                </div>

                <ul className="u_file-attachment-options">
                    {
                        checkAttachment(file?.url) === 'pdf' ?
                            <li className="u_mr-10 u_cp">
                                <a href={`${_S3_BASE_URL}${file?.url}`} target="_blank" rel="noopener noreferrer" download>
                                    <Icon.Eye size={16} fill={COLOR.u_white} />
                                </a>
                            </li>
                            :
                            <li className="u_mr-10 u_cp" onClick={() => handle.view(doc?.attachments, index)}>
                            <span>
                                <Icon.Eye size={16} fill={COLOR.u_white} />
                            </span>
                            </li>
                    }

                    {
                        // (doc?.attachments?.filter(_ => !_?.isDeleted)?.length > (type === 'edit' ? 1 : 0) && !hideDelete) &&
                        <li onClick={() => action.delete(doc, file, index)}>
                            <span>
                                <Icon.Delete fill={COLOR?.u_white} size={14} />
                            </span>
                        </li>
                    }

                </ul>
            </div>

        </React.Fragment>
    )
}


export const AddFile = ({add, hasError}) => {

    return (
        <div className={`u_file-attachment add ${hasError ? 'has-error' : ''}`}>

            <Icon.Attachment fill={hasError ? COLOR?.u_red : COLOR.u_icon_bg} size={18}/>

            <label className="u_file-attachment-label">
                <input type='file' title="" accept=".png, .jpg, .jpeg, .pdf" id="upload" multiple autoComplete="off" onChange={add} />
            </label>
        </div>
    );
}
